export const CheatsheetRoutes = {
  Cheatsheets: "/cheet/sheets",
  CreateCheatsheet: "/cheet/sheets/create",
  CheatsheetDetail: "/cheet/sheets/:id/details",
  Sheet: "/cheet/sheets/:id",
} as const;
